/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  FORM_HEADING: 'login.form.heading',
  GREETING_HEADING: 'login.greeting.heading',
  GREETING_PARAGRAPH: 'login.greeting.paragraph',
  HELMET_PAGETITLE_LOGIN_ERROR: 'login.helmet.pageTitle.loginError',
  HELMET_PAGETITLE_MFA: 'login.helmet.pageTitle.mfa',
  HELMET_PAGETITLE_SSOERROR: 'login.helmet.pageTitle.ssoError',
  HELMET_PAGETITLE_TOTP: 'login.helmet.pageTitle.totp',
  HELMET_SECTIONTITLE_LOGIN: 'login.helmet.sectionTitle',
  HELMET_SECTIONTITLE_SSOGENERICLOGOUT: 'login.helmet.sectionTitle.ssoGenericLogout',
  REGISTER_LABEL: 'login.form.register.text',
};

const enMessages = {
  // Helmet Page Titles
  [IDS.HELMET_PAGETITLE_LOGIN_ERROR]: 'Error',
  [IDS.HELMET_PAGETITLE_MFA]: 'Two-Factor Authentication',
  [IDS.HELMET_PAGETITLE_SSOERROR]: 'SSO Login Error',
  [IDS.HELMET_PAGETITLE_TOTP]: 'Temporary One-Time Passcode',
  // Login Form
  [IDS.FORM_HEADING]: 'Mortgage Online',
  [IDS.GREETING_HEADING]: 'A fast and easy way to manage your mortgage.',
  [IDS.GREETING_PARAGRAPH]: 'We\'ve rebuilt our site from the ground up to offer you convenience, flexibility, and the power to manage your account from virtually anywhere.',
  [IDS.REGISTER_LABEL]: 'New to Your Mortgage Online?',
  // Helmet Section Titles
  [IDS.HELMET_SECTIONTITLE_LOGIN]: 'Login',
  [IDS.HELMET_SECTIONTITLE_SSOGENERICLOGOUT]: 'SSO Logout',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.FORM_HEADING]: 'Murabaha Financing Transaction Online',
  [IDS.GREETING_HEADING]: 'A fast and easy way to manage your Murabaha Financing Transaction.',
  [IDS.REGISTER_LABEL]: 'New to Your Murabaha Online?',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
